/*
 * Div4MessageArea: This component renders the status messages after MFA is selected,
 *                  such as MFA verification status, email sent status and the Ok button.
 */
import React from 'react';

const Div4MessageArea = ({message, div4Error, isDiv4ButtonVisible, Div4OkClicked, activeStep}) => {

    const lines = message.split('\n');
    return (
        <div className={`child-div ${activeStep === 4 ? 'active-step' : ''}`}>
            <p className={`${div4Error ? 'app-text app-error' : 'app-text'}`}>
                {/*{message}*/}
                {lines.map((line, index) => (
                    <React.Fragment key={index}>
                        {line}<br/>
                    </React.Fragment>
                ))}
            </p>

            {
                isDiv4ButtonVisible && (
                    <button className='app-button' onClick={Div4OkClicked}>OK</button>
                )
            }
        </div>
    );
};

export default Div4MessageArea;
